// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"52820e6f","514":"7af2de70","749":"31e8864a"}[chunkId] + ".chunk.js";
};